import { Directive, forwardRef} from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[validateDomain][ngModel],[validateDomain][formControl]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => DomainValidator), multi: true }
  ]
})
export class DomainValidator {

  validate(control: AbstractControl): { [validator: string]: string } {
    const DOMAIN_REGEXP = /^(?!\-)(?:[a-zA-Z\d\-]{0,62}[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/;
    if (!control.value) {
      return null;
    }
    const value = control.value.trim();
    const domains: Array<string> = value.split(',');
    for (const domain of domains) {
      if (!(DOMAIN_REGEXP.test(domain))) {
        return { validateDomain: 'GLOBAL.INVALID_TRUSTED_DOMAINS' };
      }
    }
    return null;
  }
}